<template>
    <d2-container :filename="filename">
        <el-tabs v-model="activeName">
            <el-tab-pane label="账号信息" name="accountInfo">账号信息</el-tab-pane>
             <el-tab-pane label="修改密码" name="updatePassword">
                <el-form :model="updatePsdModal" ref="updatePsdModal" class="update-psd-wrapper"  :rules="rules">
                    <el-form-item label="原登录密码" prop="passwordForOld">
                        <el-input type="password" v-model="updatePsdModal.passwordForOld" placeholder="请输入原密码"/>
                    </el-form-item>
                    <el-form-item label="新登录密码" prop="passwordForNew">
                        <el-input type="password" v-model="updatePsdModal.passwordForNew" placeholder="请输入新密码"/>
                    </el-form-item>
                    <el-form-item label="新登录密码" prop="passwordForNewAndRepeat">
                        <el-input type="password" v-model="updatePsdModal.passwordForNewAndRepeat" placeholder="请再次输入新密码"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="submit" type="primary" class="button-submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </d2-container>
</template>

<script>
    import {UpdateSelfPassword} from '@/api/systemPrivilege/account';
    import Message from '@/util/message';
    import MessageBox from '@/util/messageBox';
    import Notification from '@/util/notification';
    import Validate from '@/util/validate';

    export default {
        data () {
            var checkPassword = (rule, value, callBack) => {
                if (!value) {
                    callBack(new Error('请输入密码，密码不能为空'));
                } else if (!Validate.checkPassword(this.updatePsdModal.passwordForNew)) {
                    return callBack(new Error('请输入以字母开头，包含字母和数字点及下划线组合，至少8位'));
                }
                callBack();
            };
            var checkConfirmPassword = (rule, value, callBack) => {
                if (!value) {
                    callBack(new Error('请再次输入密码'));
                } else if (this.updatePsdModal.passwordForNewAndRepeat !== this.updatePsdModal.passwordForNew) {
                    callBack(new Error('两次密码输入不一致，请重新输入'));
                }
                callBack();
            };
            return {
                filename: __filename,
                activeName: '',
                updatePsdModal: new Object(),
                rules: {
                    passwordForOld: [
                        {required: true, message: '请输入原密码', trigger: 'blur'}
                    ],
                    passwordForNew: [
                        {required: true, validator: checkPassword, trigger: 'blur'}
                    ],
                    passwordForNewAndRepeat: [
                        {required: true, validator: checkConfirmPassword, trigger: 'blur'}
                    ]
                }
            }
        },
        created () {
            this.initAccountTab();
        },
        methods: {
            initAccountTab () {
                var showAccountInfo = Number(this.$route.query.showAccountInfo);
                if (showAccountInfo === 2) {
                    this.activeName = 'updatePassword';
                } else {
                    this.activeName = 'accountInfo';
                }
            },
            submit () {
                this.$refs.updatePsdModal.validate(valid => {
                    if (!valid) {
                        Message.warning('请输入表单信息');
                        return;
                    }
                    UpdateSelfPassword(this.updatePsdModal).then(res => {
                        if (!res) return;
                        Notification.success('修改用户密码', res.message);
                        setTimeout(() => {
                            MessageBox.confirm('密码修改成功，请重新登录', '温馨提示', 'warning', () => {
                                this.$router.push('/login');
                            }, () => {
                                Message.info('取消重新登录');
                            });
                        }, 100);
                    });
                });
            }
        }
    }
</script>

<style lang='scss'>
    .update-psd-wrapper {
        width: 400px;
        max-width: 100%;
        margin: 50px auto;
        .button-submit {
            width: 100%;
        }
    }
</style>

